import { data } from '../../svg/MarkMessageUnread/data';
import { makeIcon } from '../makeIcon';

export const MarkMessageUnread = makeIcon(data, 'mark_email_unread', 'MarkMessageUnread');

export default MarkMessageUnread;
